import { FC, memo, useCallback } from 'react'

import { useAppDispatch } from '../../../../../redux/hooks'
import { CallbackFunction } from '../../../../../common/types'
import { ClearAllLabel, CloseIconStyled, Container, HeaderLabel } from './styles'
import { filterClear, popModal } from '../../../../../redux/filters'
import { FilterSectionTransport } from '../../../../../transports/search-result-listing-static-transport'
import { useRequestUserConfigContext } from '../../../../../hooks/request'
import { stopPropagation } from '../../../../../utils/dom-utils'

type Props = {
    handleFilterToggle: CallbackFunction
    filterStaticData: FilterSectionTransport
}

const FilterModalHeader: FC<Props> = ({ filterStaticData, handleFilterToggle }) => {
    const dispatch = useAppDispatch()
    const user = useRequestUserConfigContext()

    const handleFilterClear = useCallback(() => {
        dispatch(filterClear(user))
        dispatch(popModal())
    }, [dispatch, user])

    return (
        <Container onMouseDown={stopPropagation}>
            <CloseIconStyled onClick={handleFilterToggle} aria-label="close icon" />
            <HeaderLabel> {filterStaticData.filter} </HeaderLabel>
            <ClearAllLabel onClick={handleFilterClear}>{filterStaticData.clearAll}</ClearAllLabel>
        </Container>
    )
}

export default memo(FilterModalHeader)
